import { useEffect, useState } from "react";
import {
  getMeetingTypesForSchedule,
  getMeetingTypeDropdownState,
} from "../../users/meetingUtils";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// Dummy login and meetings data for demonstration. Replace with real context/data.
const login = { data: { role: "advisor", orgId: "123" } };
const selectedOrganization = "123";
const allMeetings = [];

const ClientInfo = () => (
  <Box display="flex" alignItems="center" gap={2} mb={2}>
    <Typography variant="h6">Client:</Typography>
    <TextField
      variant="outlined"
      size="small"
      defaultValue="John Smith"
      sx={{ width: "150px" }}
    />
    <TextField
      variant="outlined"
      size="small"
      defaultValue="John.Smith@gmail.com"
      sx={{ width: "250px" }}
    />
  </Box>
);

const AppointmentForm = () => {
  // Get meeting types for dropdown
  const meetingTypes = getMeetingTypesForSchedule({
    meetings: allMeetings,
    login,
    selectedOrganization,
  });
  const [dropdownState, setDropdownState] = useState({
    message: "",
    showContactAdmin: false,
  });

  useEffect(() => {
    setDropdownState(
      getMeetingTypeDropdownState({
        meetingTypes,
        login,
        redirectToManageMeeting: () => {
          // Example: window.location.href = '/users/manage-meetings';
          // For demo, just log
          console.log("Redirecting to Manage Meeting page...");
        },
      })
    );
    // eslint-disable-next-line
  }, [meetingTypes]);

  return (
    <Box
      border={1}
      borderColor="grey.300"
      borderRadius={2}
      p={2}
      mb={4}
      width="60%"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" gutterBottom>
          <b>Schedule Meeting</b>
        </Typography>
        <Button variant="contained" color="primary" size="small">
          Save
        </Button>
      </Box>
      <Divider />
      <h4>Meeting Type</h4>
      <Box mt={2}>
        <FormControl fullWidth>
          <Select
            displayEmpty
            defaultValue={meetingTypes[0]?.meetingType || ""}
            inputProps={{ "aria-label": "Meeting Type" }}
          >
            {meetingTypes.length === 0 ? (
              <MenuItem value="" disabled>
                {dropdownState.message}
                {dropdownState.showContactAdmin && (
                  <Typography color="error" variant="body2">
                    Contact Admin
                  </Typography>
                )}
              </MenuItem>
            ) : (
              meetingTypes.map((type) => (
                <MenuItem key={type._id} value={type.meetingType}>
                  {type.meetingType}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Box>
      {/* ...existing code for other fields... */}
      <Box mt={2}>
        <TextField
          label="Category"
          variant="outlined"
          fullWidth
          sx={{ width: "85%" }}
        />
        <IconButton>
          <ArrowDropDownIcon />
        </IconButton>
      </Box>
      <Box mt={2}>
        <TextField
          label="Initial discussion on your needs"
          variant="outlined"
          fullWidth
        />
      </Box>
      {/* ...existing code for rest of form... */}
    </Box>
  );
};

const MainContent = () => (
  <Box p={4} flexGrow={1}>
    <ClientInfo />
    <AppointmentForm />
  </Box>
);

const Dashboard = () => {
  return (
    <Box display="flex">
      <Box sx={{ flexGrow: 1, bgcolor: "#f9f9f9" }}>
        <MainContent />
      </Box>
    </Box>
  );
};

export default Dashboard;
